import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import ShareIcon from '@mui/icons-material/Share';
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    PinterestShareButton,
    RedditShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton
  } from "react-share";
  import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    PinterestIcon,
    RedditIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon
  } from "react-share";
import styled from '@emotion/styled';

const ShareButton = styled(Button)`
    background-color: unset !important;
    box-shadow: unset !important;
    color: #000000 !important;
    font-weight: 600 !important;
`
const Share = () => {
    const [ getUrl, setUrl ] = useState('');
    useEffect(()=>{
        setUrl(()=>{
            if (window?.location) {
                return window?.location?.href
            }
        })
    })
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div>
          <ShareButton variant="contained" {...bindTrigger(popupState)}>
            <ShareIcon style={{fill:"#0A0A0A", fontSize:20}} />Share
          </ShareButton>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
          >
            <Typography sx={{ p: 2 }}>
                <FacebookShareButton url={getUrl}>
                    <FacebookIcon size={30} borderRadius={8} />
                </FacebookShareButton>
                &nbsp;&nbsp;
                <TwitterShareButton url={getUrl}>
                    <TwitterIcon size={30} borderRadius={8} />
                </TwitterShareButton>
                &nbsp;&nbsp;
                <TelegramShareButton url={getUrl}>
                    <TelegramIcon size={30} borderRadius={8} />
                </TelegramShareButton>
                &nbsp;&nbsp;
                <WhatsappShareButton url={getUrl}>
                    <WhatsappIcon size={30} borderRadius={8} />
                </WhatsappShareButton>
                &nbsp;&nbsp;
                <LinkedinShareButton url={getUrl}>
                    <LinkedinIcon size={30} borderRadius={8} />
                </LinkedinShareButton>
                &nbsp;&nbsp;
                <PinterestShareButton url={getUrl}>
                    <PinterestIcon size={30} borderRadius={8} />
                </PinterestShareButton>
                &nbsp;&nbsp;
                <RedditShareButton url={getUrl}>
                    <RedditIcon size={30} borderRadius={8} />
                </RedditShareButton>
                &nbsp;&nbsp;
                <EmailShareButton url={getUrl}>
                    <EmailIcon size={30} borderRadius={8} />
                </EmailShareButton>
            </Typography>
          </Popover>
        </div>
      )}
    </PopupState>
  )
}

export default Share